/**
 * Numeric comparison of two non-negative decimal strings, without ever
 * touching floating point (BigInt scaling, like divideDecimalCeil). Postgres
 * `numeric` values arrive as strings whose scales differ between columns —
 * `compareDecimals('4', '4.000000000000000000') === 0`.
 */
export function compareDecimals(a: string, b: string): -1 | 0 | 1 {
  const [aInt, aFrac = ''] = a.split('.');
  const [bInt, bFrac = ''] = b.split('.');
  const scale = Math.max(aFrac.length, bFrac.length);
  const aScaled = BigInt(`${aInt}${aFrac.padEnd(scale, '0')}`);
  const bScaled = BigInt(`${bInt}${bFrac.padEnd(scale, '0')}`);
  if (aScaled === bScaled) return 0;
  return aScaled < bScaled ? -1 : 1;
}
